import { fmt } from './utils/formatters';

// Pro is one list price. This mirrors PRO_PRICE_CENTS in backend/config.py,
// which is what Stripe actually charges; backend/tests/test_pro_price.py fails
// the suite if any product surface still shows a retired number. Lucas,
// 2026-09-16: $249 list, $149 founding rate for the first ten shops. Change
// these here and in config.py together.
export const PRO_PRICE_MONTHLY = 249;
export const PRO_PRICE_LABEL = fmt(PRO_PRICE_MONTHLY);

// Founding-shop rate, locked for life. Mirrors FOUNDING_PRICE_CENTS. It is
// applied by a founding_rate discount code at checkout, so it only renders
// where the code is explained, never as the default price.
export const FOUNDING_PRICE_MONTHLY = 149;
export const FOUNDING_PRICE_LABEL = fmt(FOUNDING_PRICE_MONTHLY);

// Stripe's no-code customer portal for this account (Settings → Billing →
// Customer portal, activated 2026-09-17). A paying shop updates its card or
// cancels here; the app itself never handles card data. Public login link,
// safe to ship in the bundle.
export const STRIPE_PORTAL_URL = 'https://billing.stripe.com/p/login/eVq5kveAOgTQ0QZeLKfQI00';
